import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import PrincipleTable from "../../elements/Tables/PrincipleTable/PrincipleTable";
import PrincipleCreationForm from "../../elements/Forms/PrincipleCreationForm/PrincipleCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_PRINCIPLE_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deletePrinciple } from "../../../Services/PrincipleService";

const { Search } = Input;

const PrinciplePage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [principleId, setPrincipleId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setPrincipleId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deletePrinciple(principleId);
      message.success("Principle deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete principle."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_PRINCIPLE_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Principle
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <PrincipleTable
        history={history}
        loading={loading}
        data={data}
        callReFetch={callReFetch}
        userData={userData}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Principle"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <PrincipleCreationForm
          history={history}
          userData={userData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Principle"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this principle?</p>
      </Modal>
    </div>
  );
};

PrinciplePage.propTypes = {};

export default PrinciplePage;
